











































import { Component, Prop, Watch } from 'vue-property-decorator';

import { Gender } from '@/enums/Gender';
import { Store } from '@/enums/Store';

import { NamedOption } from '@/util/NamedOption';
import { User } from '@/util/User';

import { extend } from 'vee-validate';
import { email } from 'vee-validate/dist/rules';
import { callbackRuleCreator } from '@/util/Rules';

import FormGroup from '@/components/Form/InputComponents/FormGroup.vue';
import FormRadio from '@/components/Form/InputComponents/FormRadio.vue';
import FormInput from '@/components/Form/InputComponents/FormInput.vue';
import Validatable from '@/components/Validatable.vue';
import { InputType } from '@/enums/InputType';

import { namespace } from 'vuex-class';
import FormSelect from '@/components/Form/InputComponents/FormSelect.vue';
import { Event } from '@/util/Event';

const MEMBER = namespace(Store.MEMBER);
const EVENT = namespace(Store.EVENT);
const App = namespace(Store.APP);

@Component({
  components: { FormSelect, FormInput, FormRadio, FormGroup }
})
export default class BaseUserForm extends Validatable {
  @Prop({ required: true }) member!: User;
  @Prop({ default: false }) showCompany!: boolean;
  @App.State('promoterId') promoterId!: number;
  @EVENT.Getter('selectedEventObject') event!: Event;

  @MEMBER.Getter('isMemberEmailUnique') isMemberEmailUnique!: (email: string) => boolean;

  @Watch('member', { deep: true })
  updateMember() {
    this.$emit('update:member', this.member);
  }

  gender: NamedOption[] = [];
  TEXT = InputType.TEXT;
  EMAIL = InputType.EMAIL;

  changeValue() {
    this.$emit('update:member', this.member);
  }

  get hasEventGender() {
    return this.hasField('gender');
  }

  hasField($field: string): boolean {
    return this.event.ticketCategories[0].formFields.includes($field);
  }

  created(): void {
    const memberEmailValidation = callbackRuleCreator(this.isMemberEmailUnique);

    extend('email', {
      ...email,
      message: this.$t('email-invalid').toString()
    });

    extend('email-unique', {
      ...memberEmailValidation,
      message: this.$t('email-unique-invalid').toString()
    });

    this.gender = [
      new NamedOption(this.$t('male').toString(), Gender.MALE, 'male'),
      new NamedOption(this.$t('female').toString(), Gender.FEMALE, 'female')
    ];
  }
}
